import { sliderCursor } from './sliderCursor';
import { modal } from './modal';

// 共通ページ
(() => {
  // ハンバーガーメニュー
  const headerContainer = document.querySelector('.headerContainer')
  document.querySelector('.naviToggle').addEventListener('click', () => {
    headerContainer.classList.toggle('is-active')
    if (headerContainer.classList.contains('is-active')) {
      gsap.to('.headerContainer', {
        duration: 0.5,
        height: 680,
      })
    } else {
      gsap.to('.headerContainer', {
        duration: 0.5,
        height: 84,
      })
    }
  });

  // メニュー
  let globalNaviListItemSubHeights = []
  document.querySelectorAll('.globalNavi-list_item.is-submenu').forEach((globalNaviListItem, i) => {
    console.log(i);
    if (globalNaviListItem.querySelector('.globalNavi-list_item_sub') !== null) {
      const globalNaviListItemSub = globalNaviListItem.querySelector('.globalNavi-list_item_sub');
      globalNaviListItemSubHeights.push(globalNaviListItemSub.clientHeight);
      globalNaviListItemSub.style.height = 0;
      globalNaviListItemSub.style.padding = 0;
      globalNaviListItem.addEventListener('click', (e) => {
        e.currentTarget.classList.toggle('is-current');
        if (e.currentTarget.classList.contains('is-current')) {
          gsap.to(globalNaviListItemSub, {
            onStart: () => {
              globalNaviListItemSub.style.padding = '0.5em 0 1.2em';
            },
            duration: 1,
            ease: 'expo.out',
            height: globalNaviListItemSubHeights[i],
            opacity: 1,
          })
        } else {
          gsap.to(globalNaviListItemSub, {
            duration: 0.7,
            ease: 'expo.out',
            height: 0,
            padding: 0,
            opacity: 0,
          })
        }
      });
    }
  });

  // メニューリスト
  document.querySelectorAll('.menuList dt').forEach((menuList) => {
    menuList.addEventListener('click', () => {
      menuList.closest('.menuList').classList.toggle('is-active');
    })
  })

  // スムーススクロール
  const headerHeight = document.querySelector('#header').offsetHeight;
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      e.preventDefault();
      const href = anchor.getAttribute('href');
      const target = document.getElementById(href.replace('#', ''));
      const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    });
  });
})();

// トップページ
(() => {
  if (document.body.classList.contains('home')) {
    // swiper
    const swiperMvList = new Swiper('.swiper-mvList', {
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      slidesPerView: 'auto',
      allowTouchMove: false,
      speed: 800,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
    const swiperPickupList = new Swiper('.swiper-pickupList', {
      // loop: false,
      // slidesPerView: 'auto',
      // spaceBetween: 20,
      // centeredSlides : true,
      loop: false,
      slidesPerView: 'auto',
      effect: "creative",
      creativeEffect: {
        prev: {
          translate: ["-100%", 0, 0],
        },
        next: {
          translate: ["100%", 0, 0],
        },
        limitProgress: 5
      },
    });
    const swiperPublicList = new Swiper('.swiper-publicList', {
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination-publicList',
        clickable: true,
      },
    });
    const swiperArtistList = new Swiper('.swiper-artistList', {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
    });

    // swiperのcursor
    sliderCursor(document.querySelector('.swiper-pickupList'));
    sliderCursor(document.querySelector('.swiper-artistList'));

    // 申込受付中のみ表示のチェックボックス
    document.querySelector('.eventsListWrapper').style.height = `${document.querySelector('.eventsList').clientHeight + 40}px`;
    document.querySelector('.buttonInput input').addEventListener('click', (e) => {
      const buttonInput = e.currentTarget
      if (buttonInput.checked) {
        gsap.timeline()
          .to('.eventsList-top', {
            duration: 0.4,
            ease: 'expo.out',
            autoAlpha: 0,
          })
          .to('.eventsList-active', {
            duration: 0.4,
            ease: 'expo.out',
            autoAlpha: 1,
          }, 0.1);
      } else {
        gsap.timeline()
          .to('.eventsList-active', {
            duration: 0.4,
            ease: 'expo.out',
            autoAlpha: 0,
          })
          .to('.eventsList-top', {
            duration: 0.4,
            ease: 'expo.out',
            autoAlpha: 1,
          }, 0.1);
      }
    });
  }
})();

// about
(() => {
  if (document.body.classList.contains('about')) {
    // モーダル
    modal();

    // アコーディオン
    document.querySelectorAll('.sectionAcco dt').forEach((sectionAccoDt) => {
      sectionAccoDt.addEventListener('click', (e) => {
        sectionAccoDt.closest('.sectionAcco').classList.toggle('is-active');
        if (sectionAccoDt.closest('.sectionAcco').classList.contains('is-active')) {
          gsap.to(e.currentTarget.nextElementSibling, {
            duration: 1,
            ease: 'expo.out',
            height: 'auto',
          })
        } else {
          gsap.to(e.currentTarget.nextElementSibling, {
            duration: 0.8,
            ease: 'expo.out',
            height: 0,
          })
        }
      })
    })

    // swiper
    const swiperAbout03 = new Swiper('.swiper-about03', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 70,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination-about03',
        clickable: true,
      },
    });

    // swiperのcursor
    sliderCursor(document.querySelector('.swiper-about03'));

    // swiperのPC/Mobile切り替え
    const mobileSliderTargets = document.querySelectorAll('.normalSlide-sp');
    const mobileSliders = [];

    function mobileSliderOptions(slider) {
      return {
        loop: true,
        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true,
        }
      };
    }

    function sliderSetting(slider, i) {
      if (window.matchMedia('(min-width: 760px)').matches) {
        if (typeof mobileSliders[i] === 'undefined') return false;
        mobileSliders[i].destroy();
      } else {
        mobileSliders[i] = new Swiper(slider, mobileSliderOptions(slider));
      }
    }

    function handleSliderSetting() {
      mobileSliderTargets.forEach((slider, i) => {
        sliderSetting(slider, i);
      });
    }

    window.addEventListener('load', handleSliderSetting);
    window.matchMedia('(min-width: 760px)').addEventListener('change', handleSliderSetting);
  }
})();

// history
(() => {
  if (document.body.classList.contains('history')) {
    // モーダル
    modal();

    // swiper
    const swiperHistoryList = new Swiper('.swiper-historyList', {
      loop: true,
      centeredSlides: true,
      slidesPerView: '2',
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination-historyList',
        clickable: true,
      },
    });
    const swiperHistoryChronology = new Swiper('.swiper-historyChronology', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination-historyChronology',
        clickable: true,
      },
    });

    // swiperのcursor
    sliderCursor(document.querySelector('.swiper-historyList'));
    sliderCursor(document.querySelector('.swiper-historyChronology'));
  }
})();

// info
(() => {
  if (document.body.classList.contains('info')) {
    const swiperInfo = new Swiper('.swiper-info', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 75,
      pagination: {
        el: '.swiper-pagination-info',
        clickable: true,
      },
    });

    // swiperのcursor
    sliderCursor(document.querySelector('.swiper-info'));
  }
})();

// events
(() => {
  if (document.body.classList.contains('archive') || document.body.classList.contains('events_archive')) {
    if (window.matchMedia('(max-width: 760px)').matches) {
      // mobile
      document.querySelectorAll('.buttonSearch span').forEach((buttonSearchSpan) => {
        buttonSearchSpan.addEventListener('click', (e) => {
          const buttonSearch = e.currentTarget.closest('.buttonSearch');
          const searchBox = buttonSearch.nextElementSibling;
          searchBox.classList.toggle('is-active');
          if (searchBox.classList.contains('is-active')) {
            gsap.to(searchBox, {
              duration: 0.6,
              ease: 'expo.out',
              opacity: 1,
              display: 'block',
            })
            searchBox.querySelector('.buttonClose').addEventListener('click', (e) => {
              searchBox.classList.toggle('is-active');
              gsap.to(searchBox, {
                duration: 0.3,
                ease: 'expo.out',
                opacity: 0,
                display: 'none',
              })
            });
          } else {
            gsap.to(searchBox, {
              duration: 0.3,
              ease: 'expo.out',
              opacity: 0,
              display: 'none',
            })
          }
        })
      })
    }
  }
})();

// single
(() => {
  const target = document.querySelector('.swiper-eventsImage');
  if(!target) return false;

  const slideLength = target.querySelectorAll('.swiper-slide').length;

  // swiper
  const swiperEventsImage = new Swiper(target, {
    loop: false,
    centeredSlides: true,
    slidesPerView: 'auto',
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination-eventsImage',
      clickable: true,
    },
  });

  // swiperのcursor
  // 画像が1枚の場合はスキップ
  if (slideLength <= 1) return false;
  sliderCursor(target);
})();

// artist_in_studios
(() => {
  if (document.body.classList.contains('artist_in_studios')) {
    // swiper
    const swiperStudioImage = new Swiper('.swiper-studioImage', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 70,
      pagination: {
        el: '.swiper-pagination-studioImage',
        clickable: true,
      },
    });

    // swiperのcursor
    sliderCursor(document.querySelector('.swiper-studioImage'));
  }
})();

// artist_in_studios-facility
(() => {
  if (document.body.classList.contains('facility')) {
    modal();
  }
})();

// volunteer
(() => {
  if (document.body.classList.contains('volunteer')) {
    // swiper
    const swiperVolunteerImage = new Swiper('.swiper-volunteerImage', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 70,
      pagination: {
        el: '.swiper-pagination-volunteerImage',
        clickable: true,
      },
    });

    // swiperのcursor
    sliderCursor(document.querySelector('.swiper-volunteerImage'));
  }
})();

// floorguide
(() => {
  if (document.body.classList.contains('floorguide')) {
    modal();
  }
})();

// visit
(() => {
if (document.body.classList.contains('visit')) {
  // swiper
  const swiperVolunteerImage = new Swiper('.swiper-visit', {
    loop: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    spaceBetween: 70,
    pagination: {
      el: '.swiper-pagination-visit',
      clickable: true,
    },
  });

  // swiperのcursor
  sliderCursor(document.querySelector('.swiper-visit'));
}
})();

// shop-cafe
(() => {
  if (document.body.classList.contains('shop-cafe')) {
    // swiper
    const swiperStudioImage = new Swiper('.swiper-cafeImage', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 70,
      pagination: {
        el: '.swiper-pagination-cafeImage',
        clickable: true,
      },
    });

    // swiperのcursor
    sliderCursor(document.querySelector('.swiper-cafeImage'));
  }
})();

// faq
(() => {
  if (document.body.classList.contains('faq')) {
    let faqBlockHeights = [];
    document.querySelectorAll('.faqBlock').forEach((faqBlock, i) => {
      const faqBlockDd = faqBlock.querySelector('dd');
      faqBlockHeights.push(faqBlockDd.clientHeight);
      faqBlockDd.style.height = 0;
      faqBlockDd.style.padding = 0;
      faqBlock.querySelector('dt').addEventListener('click', () => {
        faqBlock.classList.toggle('is-active');
        if (faqBlock.classList.contains('is-active')) {
          gsap.to(faqBlockDd, {
            onStart: () => {
              faqBlockDd.style.padding = '18px 25px 18px 45px';
            },
            duration: 1,
            ease: 'expo.out',
            height: faqBlockHeights[i],
            opacity: 1,
          })
        } else {
          gsap.to(faqBlockDd, {
            duration: 0.7,
            ease: 'expo.out',
            height: 0,
            padding: 0,
            opacity: 0,
          })
        }
      })
    });
  }
})();
